import React from 'react';

import { convertCentsToDollars } from '@clearverify/utils';

import { FullscreenLoader } from 'src/components/common';
import { useVerifierBillingRules, useVerifierParamId } from 'src/hooks/verifier';

import { BillingRulesForm } from './BillingRulesForm';

export const BillingRulesTab: React.FC = () => {
  const verifierId = useVerifierParamId();
  const { verifierBilling, updateVerifierBillingRules, loading } =
    useVerifierBillingRules(verifierId);

  const verifierBillingData = verifierBilling?.verifierBilling;
  const verificationOfIncome = convertCentsToDollars(verifierBillingData?.voI);
  const verificationOfEmployment = convertCentsToDollars(verifierBillingData?.voE);
  const reverification = convertCentsToDollars(verifierBillingData?.reverification);

  if (loading) {
    return <FullscreenLoader />;
  }

  return (
    <BillingRulesForm
      voI={verificationOfIncome}
      voE={verificationOfEmployment}
      reverification={reverification}
      updateVerifierBillingRules={updateVerifierBillingRules}
    />
  );
};
